/** Throws a uniform "called on browser build" error for native-only plugin stubs. */
export function makeFail(pluginName: string): (op: string) => never {
  return (op: string): never => {
    throw new Error(`${pluginName} stub: ${op} called on browser build`);
  };
}
